import builder from '../builder';
import CameraFlash from '../../streamline-icons/light/camera-flash.svg';

export default builder('IconCameraFlashLight', CameraFlash);
